export const founderSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Prembhai Mali",
  "jobTitle": "Founder & Mechanical Engineer",
  "description":
    "Prembhai Mali is the founder of Devi Plastic and a mechanical engineer specializing in precision die-making and plastic manufacturing for sink couplings.",
  "image": "https://www.deviplastic.in/founder.png",
  "worksFor": {
    "@type": "Organization",
    "name": "Devi Plastic",
    "url": "https://www.deviplastic.in"
  },
  "founderOf": {
    "@type": "Organization",
    "name": "Devi Plastic",
    "url": "https://www.deviplastic.in"
  },
  "knowsAbout": [
    "Mechanical Engineering",
    "Plastic Manufacturing",
    "Sink Coupling Manufacturing",
    "Precision Die Making",
    "Drainage Fittings"
  ],
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Ahmedabad",
    "addressRegion": "Gujarat",
    "addressCountry": "IN"
  }
};
